module.exports = __webpack_public_path__ + "static/media/parked_d.e08d9d2b.png";